// extracted by mini-css-extract-plugin
module.exports = {"container":"gz","image":"gA","title":"gB","date":"gC"};